export {};

function togglePasswordVisibility(btn: HTMLButtonElement) {
    const input = btn.parentElement!.getElementsByTagName("input")[0]!;
    const reveal = input.type === "password";
    input.type = reveal ? "text" : "password";
    input.focus();
    btn.setAttribute("aria-pressed", String(reveal));
    const icon = btn.querySelector(".k-icon")!;
    icon.classList.toggle("k-i-eye", !reveal);
    icon.classList.toggle("k-i-eye-slash", reveal);
}

document
    .querySelectorAll<HTMLButtonElement>("[data-toggle-password-reveal]")
    .forEach(btn => btn.addEventListener("click", () => togglePasswordVisibility(btn)));
